module.exports = __webpack_public_path__ + "img/available-location.858b1102.svg";